import {Position, PositionBalance} from '@/providers/overview/OverviewProvider';
import {TOKEN_ADDRESS} from '@/util/chains';
import {GROWTH_RANGE} from '@/providers/overview/constants';
import {firstNonZeroValueFrom} from '@/util/firstNonZeroValueFrom';

export const addPositionChartData = (position: Position) => {
  position.balances.sort((a, b) => a.timestamp - b.timestamp);
  position.events.sort((a, b) => a.timestamp - b.timestamp);

  let j = 0;
  let lastBalance: PositionBalance | undefined;
  let hasData = false;

  position.chartData = position.chartData.map(({timestamp}) => {
    while (
      j < position.balances.length &&
      position.balances[j].timestamp < timestamp
    ) {
      lastBalance = position.balances[j];
      j++;
    }

    if (lastBalance) {
      const value = lastBalance.getValueAt(timestamp);
      if (value > 0) {
        hasData = true;
      }
      return {
        timestamp,
        value,
      };
    }

    return {
      timestamp,
      value: 0,
    };
  });

  // if (!hasData) {
  //   console.log(position);
  //   throw new Error('missing chart data');
  // }

  const latestPrice =
    position.chartData[position.chartData.length - 1]?.value || 0;
  const prevPrice =
    firstNonZeroValueFrom(
      position.chartData,
      position.chartData.length - GROWTH_RANGE - 1,
      'value'
    )?.value || latestPrice;

  position.growth =
    prevPrice === 0 ? 0 : ((latestPrice - prevPrice) * 100) / prevPrice;
  position.value =
    position.chartData[position.chartData.length - 1]?.value || 0;
  position.balance =
    position.balances[position.balances.length - 1]?.balance || '0';

  if (position.type === 'Stake') {
    position.assets = [
      {
        id: TOKEN_ADDRESS,
        name: 'KEI finance',
        symbol: 'KEI',
        balance: position.balance,
        value: position.value,
        color: position.color,
        decimals: 18,
        image: position.image,
      },
    ];
  } else if (position.type === 'Token') {
    position.assets = [
      {
        id: position.id,
        name: position.name,
        symbol: position.symbol,
        balance: position.balance,
        value: position.value,
        color: position.color,
        decimals: position.decimals,
        image: position.image,
      },
    ];
  }
};
